module.exports = __webpack_public_path__ + "img/settings.3190cebe.svg";